import React from 'react';
import { Link } from 'react-router-dom';

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    fontFamily: 'Rubik, sans-serif',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    padding: '48px 64px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 32,
  },
  logo: {
    width: 80,
    height: 80,
  },
  title: {
    margin: 0,
    fontSize: 24,
    fontWeight: 600,
    color: '#1a1a1a',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
  link: {
    display: 'block',
    padding: '20px 48px',
    borderRadius: 8,
    backgroundColor: '#008080',
    color: '#fff',
    textDecoration: 'none',
    fontSize: 20,
    fontWeight: 500,
    textAlign: 'center',
    transition: 'background-color 0.2s',
  },
};

export function HomePage() {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img src="/pricetag/pricetag.svg" alt="Price Tag" style={styles.logo} />
        <h1 style={styles.title}>Master Data Retail Price Demo</h1>
        <nav style={styles.nav}>
          <Link to="/pricepublisher" style={styles.link}>
            Price Publisher
          </Link>
          <Link to="/pricesubscriber" style={styles.link}>
            Price Subscriber
          </Link>
          <Link to="/pricetags" style={styles.link}>
            Pricetag
          </Link>
        </nav>
      </div>
    </div>
  );
}
